import React, { useState, useEffect } from "react";
import { Box, Flex } from "rebass/styled-components";
import { SettingsContainer } from "../../../components/molecules/settingsContainer";
import { Error } from "../../../components/atoms/form/error";
import { LabeledInputText } from "../../../components/atoms/form/labeledInput";
import { Button } from "../../../components/atoms/form/button";
import { Success } from "../../../components/atoms/form/success";
import { AlertIcon } from "../../../components/atoms/icons";
import isEmail from "validator/lib/isEmail";
import { useForm } from "react-hook-form";
import { UPDATE_EMAIL } from "../../../MVVM/GraphQL/updateEmail";
import { DividerAlt } from "../../../components/atoms/dividerAlt";
import { URLS } from "../../../utils";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { useMutation } from "@apollo/client";
import { User } from "../../../MVVM/Model/User";
import { useUser } from "../../../MVVM/Hooks/useUser";
import { UserStatePreFill } from "../../../MVVM/Hooks/userStatePreFill";
import { useRecoilState } from "recoil";
import { xsollaModalOpen } from "../../../MVVM/State";
import { useTranslation } from "react-i18next";

const StyledSettingsContainer = styled(SettingsContainer)`
  ${(props) => {
    if (props.isPopup) {
      return `
      background: none;
      border: none;
      padding:0px;`;
    }
  }}
`;

export function EmailAddress({
  allstarUser,
  getFreshProfile,
  isPopup,
  setModalOpen,
}) {
  const history = useHistory();
  const userModel = User.getInstance();
  const [done, setDone] = useState(false);
  const [paystationOpen, setPaystationOpen] = useRecoilState(xsollaModalOpen);
  const {
    handleSubmit,
    register,
    reset,
    formState,
    formState: { errors },
  } = useForm();
  const { t } = useTranslation(`translation`, {
    keyPrefix: "profile.account",
  });
  const { logout } = useUser();
  let [state, setState] = useState({
    error: false,
    success: false,
    errorMsg: "",
    successMsg: "Profile updated!",
    username: allstarUser?.user?.profile?.username,
    country: allstarUser?.user?.profile?.profile?.countryCode || "",
  });

  const [updateEmail] = useMutation(UPDATE_EMAIL, {
    onError: (err) => {
      console.log(err);
      setState({ ...state, error: true, errorMsg: err.message });
    },
    onCompleted: async () => {
      try {
        const decoded = await userModel.DecodeToken();
        const refreshToken = decoded.refreshToken;
        const newToken = await userModel.RefreshToken(refreshToken);
        localStorage.setItem("token", newToken);

        await getFreshProfile();
        setDone(true);
        if (isPopup) {
          if (paystationOpen.pendingEmail) {
            setPaystationOpen({
              ...paystationOpen,
              isModalOpen: true,
              pendingEmail: false,
            });
          }
          if (setModalOpen) {
            setModalOpen(false);
          }
        }
        setState({ ...state, success: true, successmsg: "Email set!" });
      } catch (e) {
        logout();
      }
    },
  });

  useEffect(() => {
    if (!state.success && !state.error) return;
    setTimeout(() => {
      return setState((state) => {
        return {
          ...state,
          success: false,
          error: false,
          errorMsg: "",
        };
      });
    }, 5000);
  }, [state.success, state.error]);

  const onSubmit = async (form) => {
    form = await extractDirtyFields(form);

    //validator gaurantees we have a valid email here, make request to set it and display any errors
    updateEmail({ variables: { email: form.email } });
  };

  async function extractDirtyFields(form) {
    let dirty = {};
    Object.keys(form).forEach((key) => {
      if (formState.dirtyFields.hasOwnProperty(key)) {
        dirty[key] = form[key];
      }
    });
    return dirty;
  }

  return (
    <StyledSettingsContainer
      title={isPopup ? null : t("emailAddress")}
      mb={5}
      isPopup={isPopup}
    >
      {done && <UserStatePreFill />}
      {isPopup ? <></> : <DividerAlt></DividerAlt>}

      <Flex alignItems="center" pb={5}>
        <Box position="relative">
          <AlertIcon size={30} color="envy"></AlertIcon>
        </Box>
        <Box pl={[5, 5, 3, 3]}>{t("emailAddressBody")}</Box>
      </Flex>
      <form onSubmit={handleSubmit(onSubmit)}>
        <LabeledInputText
          mt={isPopup ? 0 : 6}
          input={{
            id: "email",
            name: "email",
            defaultValue: allstarUser?.user?.noEmailSet
              ? undefined
              : allstarUser.decoded?.sub,
            disabled: !allstarUser?.user?.noEmailSet,
            ...register("email", {
              required: true,
              validate: (value) =>
                isEmail(value) ? true : "Invalid email address",
            }),
          }}
          label={"Email"}
          error={errors.email}
          placeholder={t("emailAddress")}
        />

        {state.error ? <Error> {state.errorMsg}</Error> : <></>}
        {state.success ? <Success>{state.successMsg}</Success> : <></>}
        <Flex pt={[5]} justifyContent="flex-start">
          <Button size="small" flex={true} mt={3} disabled={!formState.dirty}>
            {t("saveEmail")}
          </Button>
          <Button
            type="button"
            size="small"
            flex={true}
            classification="subtle"
            ml={4}
            mt={3}
            onClick={() => {
              if (isPopup) {
                history.push(`/${URLS.ACCOUNT_SETTINGS}`);
              }
              reset({ dirtyFields: false, isSubmitted: false });
              setState({
                ...state,
                error: false,
                success: false,
                errorMsg: "",
              });
            }}
          >
            Cancel
          </Button>
        </Flex>
      </form>
    </StyledSettingsContainer>
  );
}
